// import React, { useState } from 'react';
// import styles from './ContactPage.module.css';
//
// const ContactPage = () => {
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [submitMessage, setSubmitMessage] = useState('');
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         message: ''
//     });
//
//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };
//
//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         setIsSubmitting(true);
//
//         // Имитация отправки формы
//         setTimeout(() => {
//             setIsSubmitting(false);
//             setSubmitMessage('Сообщение отправлено! Спасибо, что связались. Отвечу так скоро, как только смогу (и найду где тут кнопка "Ответить") 😊');
//             setFormData({ name: '', email: '', message: '' });
//
//             setTimeout(() => setSubmitMessage(''), 5000);
//         }, 2000);
//     };
//
//     return (
//         <div className={styles.contactPage}>
//             <div className={styles.contactContainer}>
//                 <h1 className={styles.pageTitle}>Давайте поговорим 💬</h1>
//                 <p className={styles.pageSubtitle}>Не стесняйтесь - я не кусаюсь (обычно) 😄</p>
//
//                 <div className={styles.content}>
//                     <div className={styles.textSection}>
//                         <p className={styles.intro}>
//                             Этот блог — мое личное пространство для мыслей и экспериментов.
//                             Иногда эти мысли находят отклик у других людей, и это прекрасно!
//                         </p>
//
//                         <div className={styles.description}>
//                             <h3>Что здесь можно найти? 🔍</h3>
//                             <p>Мысли и зарисовки: впечатления от мест, где удалось побывать,
//                                 и наблюдения из повседневной жизни, которыми показалось стоит поделиться.</p>
//                         </div>
//
//                         <div className={styles.description}>
//                             <h3>Если у вас есть что сказать? 🗣️</h3>
//                             <p>Предложите тему для поста, укажите на ошибку,
//                                 поделитесь идеей для сотрудничества или просто выскажите мнение —
//                                 я буду рад любой активности. Не обещаю мгновенный ответ, но обещаю, что прочту и отвечу (если не забуду, где тут кнопка "Ответить").</p>
//                         </div>
//
//                         <div className={styles.funFacts}>
//                             <h3>Интересные факты: 🤓</h3>
//                             <ul>
//                                 <li>Среднее время ответа: быстрее, чем доставка пиццы 🍕</li>
//                                 <li>Шанс получить ответ: 99.9% (0.1% - если меня съели инопланетяне) 👽</li>
//                                 <li>Любимая тема для разговора: технологии и котики 🐱</li>
//                             </ul>
//                         </div>
//
//                         <div className={styles.contactButtons}>
//                             <a
//                                 href="mailto:vivera83@bk.ru"
//                                 className={styles.contactButton}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 title="Написать на почту"
//                             >
//                                 <span className={styles.buttonEmoji}>📧</span>
//                                 <span>Почта</span>
//                                 <span className={styles.buttonHint}>Отвечаю в течение 24 часов (иногда 48, если много кофе)</span>
//                             </a>
//
//                             <a
//                                 href="https://t.me/Vivera83"
//                                 className={styles.contactButton}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 title="Написать в Telegram"
//                             >
//                                 <span className={styles.buttonEmoji}>📱</span>
//                                 <span>Telegram</span>
//                                 <span className={styles.buttonHint}>Отвечаю быстрее, но могу заспамить стикерами</span>
//                             </a>
//
//                             <a
//                                 href="https://vivera83.github.io/"
//                                 className={styles.contactButton}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 title="Посмотреть GitHub профиль"
//                             >
//                                 <span className={styles.buttonEmoji}>💻</span>
//                                 <span>GitHub</span>
//                                 <span className={styles.buttonHint}>Там много кода и мало комментариев (как в хорошем кино)</span>
//                             </a>
//                         </div>
//                     </div>
//
//                     <div className={styles.formSection}>
//                         <h2 className={styles.formTitle}>Или просто напишите здесь ✍️</h2>
//                         <p className={styles.formSubtitle}>Заполните форму ниже, и я отвечу быстрее, чем исчезнет печенье 🍪</p>
//
//                         <form className={styles.contactForm} onSubmit={handleSubmit}>
//                             <div className={styles.formGroup}>
//                                 <label htmlFor="name" className={styles.label}>
//                                     Ваше имя
//                                     <span className={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     id="name"
//                                     name="name"
//                                     value={formData.name}
//                                     onChange={handleInputChange}
//                                     className={styles.input}
//                                     placeholder="Как к вам обращаться? (Можно придумать!)"
//                                     required
//                                 />
//                             </div>
//
//                             <div className={styles.formGroup}>
//                                 <label htmlFor="email" className={styles.label}>
//                                     Email
//                                     <span className={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="email"
//                                     id="email"
//                                     name="email"
//                                     value={formData.email}
//                                     onChange={handleInputChange}
//                                     className={styles.input}
//                                     placeholder="Для ответа (обещаю не спамить!)"
//                                     required
//                                 />
//                             </div>
//
//                             <div className={styles.formGroup}>
//                                 <label htmlFor="message" className={styles.label}>
//                                     Сообщение
//                                     <span className={styles.required}>*</span>
//                                 </label>
//                                 <textarea
//                                     id="message"
//                                     name="message"
//                                     value={formData.message}
//                                     onChange={handleInputChange}
//                                     className={styles.textarea}
//                                     rows={5}
//                                     placeholder="О чем хотите поговорить? (Можно о котиках 🐱)"
//                                     required
//                                 ></textarea>
//                             </div>
//
//                             <button
//                                 type="submit"
//                                 className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''}`}
//                                 disabled={isSubmitting}
//                             >
//                                 {isSubmitting ? (
//                                     <>
//                                         <span className={styles.spinner}></span>
//                                         Отправляем...
//                                     </>
//                                 ) : (
//                                     <>
//                                         Отправить сообщение
//                                         <span className={styles.sendEmoji}>🚀</span>
//                                     </>
//                                 )}
//                             </button>
//
//                             {submitMessage && (
//                                 <div className={styles.successMessage}>
//                                     <span className={styles.successEmoji}>🎉</span>
//                                     {submitMessage}
//                                 </div>
//                             )}
//                         </form>
//
//                         <div className={styles.privacyNote}>
//                             <p>🔒 Ваши данные в безопасности. Я не продаю их третьим лицам (разве что за очень много кофе)</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ContactPage;

import React, { useState, useEffect } from 'react';
import styles from './ContactPage.module.css';
import useCreateFeedback, {FeedbackFormData} from "../hooks/useFeedbackForm";


const ContactPage = () => {
    const [submitMessage, setSubmitMessage] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const { createFeedback, isLoading, error, data } = useCreateFeedback();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const feedbackData: FeedbackFormData = {
            username: formData.name,
            email: formData.email,
            message: formData.message
        };

        try {
            await createFeedback(feedbackData);
            setFormData({ name: '', email: '', message: '' });
            setSubmitMessage('Сообщение отправлено! Спасибо, что связались. Отвечу так скоро, как только смогу (и найду где тут кнопка "Ответить") 😊');
        } catch (err) {
            // Ошибка уже обрабатывается в хуке, здесь можно добавить дополнительную логику
            console.error('Ошибка при отправке формы:', err);
        }
    };

    // Эффект для обработки успешной отправки и очистки сообщения
    useEffect(() => {
        if (data && data.status === 'success') {
            const timer = setTimeout(() => {
                setSubmitMessage('');
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [data]);

    // Эффект для обработки ошибок
    useEffect(() => {
        if (error) {
            setSubmitMessage(`Ошибка при отправке: ${error}`);
            const timer = setTimeout(() => {
                setSubmitMessage('');
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [error]);

    return (
        <div className={styles.contactPage}>
            <div className={styles.contactContainer}>
                <h1 className={styles.pageTitle}>Давайте поговорим 💬</h1>
                <p className={styles.pageSubtitle}>Не стесняйтесь - я не кусаюсь (обычно) 😄</p>

                <div className={styles.content}>
                    <div className={styles.textSection}>
                        <p className={styles.intro}>
                            Этот блог — мое личное пространство для мыслей и экспериментов.
                            Иногда эти мысли находят отклик у других людей, и это прекрасно!
                        </p>

                        <div className={styles.description}>
                            <h3>Что здесь можно найти? 🔍</h3>
                            <p>Мысли и зарисовки: впечатления от мест, где удалось побывать,
                                и наблюдения из повседневной жизни, которыми показалось стоит поделиться.</p>
                        </div>

                        <div className={styles.description}>
                            <h3>Если у вас есть что сказать? 🗣️</h3>
                            <p>Предложите тему для поста, укажите на ошибку,
                                поделитесь идеей для сотрудничества или просто выскажите мнение —
                                я буду рад любой активности. Не обещаю мгновенный ответ, но обещаю, что прочту и отвечу (если не забуду, где тут кнопка "Ответить").</p>
                        </div>

                        <div className={styles.funFacts}>
                            <h3>Интересные факты: 🤓</h3>
                            <ul>
                                <li>Среднее время ответа: быстрее, чем доставка пиццы 🍕</li>
                                <li>Шанс получить ответ: 99.9% (0.1% - если меня съели инопланетяне) 👽</li>
                                <li>Любимая тема для разговора: технологии и котики 🐱</li>
                            </ul>
                        </div>

                        <div className={styles.contactButtons}>
                            <a
                                href="mailto:vivera83@bk.ru"
                                className={styles.contactButton}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Написать на почту"
                            >
                                <span className={styles.buttonEmoji}>📧</span>
                                <span>Почта</span>
                                <span className={styles.buttonHint}>Отвечаю в течение 24 часов (иногда 48, если много кофе)</span>
                            </a>

                            <a
                                href="https://t.me/Vivera83"
                                className={styles.contactButton}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Написать в Telegram"
                            >
                                <span className={styles.buttonEmoji}>📱</span>
                                <span>Telegram</span>
                                <span className={styles.buttonHint}>Отвечаю быстрее, но могу заспамить стикерами</span>
                            </a>

                            <a
                                href="https://vivera83.github.io/"
                                className={styles.contactButton}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Посмотреть GitHub профиль"
                            >
                                <span className={styles.buttonEmoji}>💻</span>
                                <span>GitHub</span>
                                <span className={styles.buttonHint}>Там много кода и мало комментариев (как в хорошем кино)</span>
                            </a>
                        </div>
                    </div>

                    <div className={styles.formSection}>
                        <h2 className={styles.formTitle}>Или просто напишите здесь ✍️</h2>
                        <p className={styles.formSubtitle}>Заполните форму ниже, и я отвечу быстрее, чем исчезнет печенье 🍪</p>

                        <form className={styles.contactForm} onSubmit={handleSubmit}>
                            <div className={styles.formGroup}>
                                <label htmlFor="name" className={styles.label}>
                                    Ваше имя
                                    <span className={styles.required}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={styles.input}
                                    placeholder="Как к вам обращаться? (Можно придумать!)"
                                    required
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label htmlFor="email" className={styles.label}>
                                    Email
                                    <span className={styles.required}>*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    className={styles.input}
                                    placeholder="Для ответа (обещаю не спамить!)"
                                    required
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label htmlFor="message" className={styles.label}>
                                    Сообщение
                                    <span className={styles.required}>*</span>
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    className={styles.textarea}
                                    rows={5}
                                    placeholder="О чем хотите поговорить? (Можно о котиках 🐱)"
                                    required
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className={`${styles.submitButton} ${isLoading ? styles.submitting : ''}`}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className={styles.spinner}></span>
                                        Отправляем...
                                    </>
                                ) : (
                                    <>
                                        Отправить сообщение
                                        <span className={styles.sendEmoji}>🚀</span>
                                    </>
                                )}
                            </button>

                            {submitMessage && (
                                <div className={`${styles.message} ${error ? styles.errorMessage : styles.successMessage}`}>
                                    <span className={styles.messageEmoji}>{error ? '❌' : '🎉'}</span>
                                    {submitMessage}
                                </div>
                            )}
                        </form>

                        <div className={styles.privacyNote}>
                            <p>🔒 Ваши данные в безопасности. Я не продаю их третьим лицам (разве что за очень много кофе)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;